// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__1WFvE"};